export const trigger = {
  data () {
    return {
      loaded: false
    }
  },
  methods: {
    wp ({ going, direction }) {
      if (going === 'in' && direction === 'top') {
        this.loaded = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/functionality/mixins.js